// extracted by mini-css-extract-plugin
export default {"left-menu":"ManageCenter_left-menu__xj+T8"};